'use client'
import { setPlanID } from '@/app/globalRedux/signUp/signUp'
import { AppDispatch, RootState } from '@/app/globalRedux/store'
import useLoginRouter from '@/app/hooks/useLoginRouter'
import { useTranslation } from '@/app/i18n/client'
import { SubscriptionType } from '@/app/types/subscriptionType'
import { Button } from '@/components/ui/button'
import { useParams, useRouter } from 'next/navigation'
import { useDispatch, useSelector } from 'react-redux'

const SubscriptionButton = ({
  subscriptionType,
}: {
  subscriptionType: string
}) => {
  const router = useRouter()
  const params = useParams()
  const dispatch: AppDispatch = useDispatch()
  const navigateToLogin = useLoginRouter()

  const { t } = useTranslation()
  const { paidSubscription: subscription, loggedIn } = useSelector(
    (state: RootState) => state.user
  )
  const subscriptionLevels = ['Free', 'Silver', 'Gold', 'Platinum']

  const { subscriptionsList } = useSelector((state: RootState) => {
    return state.constantData
  })

  const currentSubscriptionIndex = subscriptionLevels.indexOf(subscription)
  const subscriptionTypeIndex = subscriptionLevels.indexOf(subscriptionType)

  if (subscriptionTypeIndex > currentSubscriptionIndex) {
    return (
      <Button
        className="mt-4 text-white"
        value={subscriptionType}
        onClick={() => {
          if (!loggedIn) {
            navigateToLogin('signup')
          } else {
            subscriptionsList.find((subscription: SubscriptionType) => {
              if (subscription.name == subscriptionType) {
                dispatch(setPlanID(subscription.id))
              }
            })
            router.push(`/${params?.lng}/signup/stripe-payment`)
          }
        }}
      >
        {loggedIn ? t('UPGRADE') : t('SUBSCRIBE')}
      </Button>
    )
  }

  if (subscriptionType === subscription) {
    return (
      <div className="mt-4 text-[#7bb419] uppercase text-[16px] font-ns_bold">
        {t('Current plan')}
      </div>
    )
  }

  return null
}

export default SubscriptionButton
